import * as React from "react"
import {BannerModuleStyles} from "./BannerModuleStyles"
import {Link} from "gatsby"
import {StaticImage} from "gatsby-plugin-image"
import {ParallaxProvider, Parallax} from "react-scroll-parallax"

const BannerModule = ({children, small}) => {
  const isServer = typeof window === "undefined"

  const parallaxValue = () => {
    if (!isServer) {
      if (window.innerWidth < 768) {
        // return [-40,20]
        return [0, 0]
      } else if (window.innerWidth < 1024) {
        return [-40, 20]
      } else {
        return [-60, 45]
      }
    } else {
      return [-60, 45]
    }
  }

  const animationValue = () => {
    if (!isServer) {
      if (window.innerWidth < 768) {
        return ''
      }
      // else if (window.innerWidth < 1024) {
      //   return ''
      // }
      else {
        return ' active'
      }
    } else {
      return ' active'
    }
  }

  let theHeaderImage

  if (!small) {
    theHeaderImage = (
        <Parallax translateY={parallaxValue()} className={"banner__image"}>
          <div className={"background"}>
            <div className="noise"></div>
            <div className="svgWrappers">
              <div className={"innerCircle"+ animationValue()}>
                <div className="innerAnim">
                  <svg viewBox="0 0 540.82 540.82">
                    <polygon className="cls-1"
                             points="379.33 273.87 540.82 270.57 379.33 267.02 540.29 253.59 378.91 260.19 538.71 236.68 378.04 253.4 536.06 219.9 376.77 246.67 532.36 203.32 375.07 240.04 527.63 187 372.95 233.53 521.89 171.02 370.44 227.16 515.15 155.42 367.52 220.97 507.45 140.28 364.23 214.97 498.81 125.65 360.56 209.19 489.27 111.6 356.54 203.65 478.87 98.17 352.18 198.37 467.64 85.42 347.49 193.38 455.63 73.4 342.51 188.69 442.9 62.16 337.23 184.32 429.48 51.74 331.69 180.3 415.44 42.18 325.91 176.63 400.82 33.53 319.92 173.33 385.69 25.81 313.72 170.41 370.1 19.05 307.36 167.89 354.13 13.29 300.85 165.77 337.81 8.54 294.22 164.07 321.24 4.82 287.49 162.78 304.46 2.15 280.7 161.92 287.55 .54 273.87 161.49 270.57 0 267.02 161.49 253.59 .52 260.19 161.91 236.68 2.11 253.4 162.77 219.9 4.76 246.67 164.05 203.32 8.45 240.04 165.75 187 13.18 233.53 167.87 171.02 18.93 227.17 170.38 155.42 25.67 220.97 173.29 140.28 33.37 214.97 176.59 125.65 42.01 209.19 180.26 111.6 51.55 203.65 184.28 98.17 61.95 198.37 188.64 85.42 73.18 193.38 193.33 73.4 85.18 188.69 198.31 62.16 97.92 184.33 203.59 51.74 111.33 180.3 209.13 42.18 125.38 176.63 214.9 33.53 140 173.33 220.9 25.81 155.13 170.41 227.1 19.05 170.71 167.89 233.46 13.29 186.69 165.77 239.97 8.54 203 164.07 246.6 4.82 219.58 162.78 253.32 2.15 236.36 161.92 260.11 .54 253.27 161.49 266.95 0 270.25 161.48 273.79 .52 287.22 161.91 280.63 2.11 304.14 162.78 287.42 4.76 320.92 164.05 294.14 8.45 337.5 165.74 300.78 13.18 353.81 167.87 307.28 18.93 369.8 170.38 313.65 25.67 385.4 173.3 319.85 33.37 400.54 176.58 325.85 42.01 415.16 180.26 331.63 51.55 429.22 184.28 337.17 61.95 442.65 188.64 342.44 73.18 455.4 193.32 347.44 85.18 467.41 198.32 352.12 97.92 478.66 203.58 356.5 111.33 489.08 209.12 360.52 125.38 498.63 214.9 364.18 139.99 507.29 220.9 367.49 155.13 515.01 227.09 370.4 170.71 521.77 233.46 372.93 186.69 527.53 239.97 375.05 203 532.28 246.6 376.75 219.58 536 253.32 378.03 236.35 538.66 260.11 378.89 253.27 540.27 266.95 379.33 270.24 540.82 273.79 379.33 287.22 540.29 280.63 378.91 304.14 538.71 287.42 378.04 320.92 536.06 294.14 376.77 337.5 532.36 300.78 375.07 353.81 527.63 307.28 372.95 369.8 521.89 313.66 370.45 385.39 515.15 319.85 367.52 400.54 507.45 325.85 364.22 415.16 498.81 331.63 360.56 429.22 489.27 337.17 356.54 442.65 478.87 342.45 352.18 455.4 467.64 347.43 347.49 467.42 455.63 352.13 342.51 478.66 442.9 356.49 337.23 489.08 429.48 360.52 331.7 498.63 415.44 364.19 325.91 507.29 400.82 367.49 319.92 515.01 385.69 370.4 313.72 521.77 370.1 372.93 307.36 527.53 354.12 375.04 300.85 532.28 337.82 376.75 294.22 536 321.24 378.04 287.5 538.66 304.46 378.89 280.7 540.27 287.55 379.33 273.87"></polygon>
                  </svg>
                </div>
              </div>
              <div className="triangleWrapper">
                <svg className="triangle-canvas" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
                  <polygon className="triangle triangle-1" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-2" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-3" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-4" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-5" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-6" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-7" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-8" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-9" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-10" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-11" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-12" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-13" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-14" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-15" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-16" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-17" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-18" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-19" points="500,200 759,650 241,650"/>
                  <polygon className="triangle triangle-20" points="500,200 759,650 241,650"/>
                </svg>
              </div>
              <div className={"outerCircle" + animationValue()}>
                <div className="innerAnim">
                  <svg viewBox="0 0 1855.18 1879.39">
                    <path className="cls-1"
                          d="m1240.98,54.41l84.66,72.52c4.22,3.61,4.48,10.04.58,13.99l-546.62,552.46c-3.53,3.56-9.21,3.8-13.02.54h0c-3.81-3.26-4.45-8.91-1.47-12.94L1227.07,55.99c3.3-4.46,9.69-5.19,13.91-1.58Z"></path>
                    <path className="cls-1"
                          d="m1524.87,214.99l54.75,97.1c2.73,4.83.78,10.97-4.24,13.34l-702.6,332.18c-4.53,2.14-9.95.42-12.41-3.95h0c-2.46-4.37-1.13-9.9,3.05-12.67l647.85-429.28c4.63-3.07,10.88-1.56,13.61,3.27Z"></path>
                    <path className="cls-1"
                          d="m1736.71,462.97l18.24,109.97c.91,5.48-3.02,10.57-8.55,11.08l-773.84,71.85c-4.99.46-9.5-3.01-10.32-7.96h0c-.82-4.95,2.32-9.69,7.2-10.86l755.6-181.82c5.4-1.3,10.76,2.26,11.67,7.73Z"></path>
                    <path className="cls-1"
                          d="m1850.96,768.46l-20.47,109.57c-1.02,5.46-6.45,8.9-11.82,7.49l-751.75-197.16c-4.85-1.27-7.89-6.07-6.97-11h0c.92-4.93,5.49-8.31,10.48-7.74l772.22,87.58c5.51.63,9.34,5.8,8.32,11.26Z"></path>
                    <path className="cls-1"
                          d="m1853.85,1094.6l-56.71,95.96c-2.82,4.78-9.11,6.16-13.67,3l-638.98-442.38c-4.12-2.85-5.34-8.41-2.79-12.72h0c2.55-4.32,8-5.93,12.49-3.69l695.7,346.41c4.97,2.47,6.79,8.64,3.97,13.42Z"></path>
                    <path className="cls-1"
                          d="m1745.01,1402.05l-86.12,70.78c-4.29,3.52-10.67,2.67-13.87-1.86l-449.14-634.24c-2.9-4.09-2.14-9.73,1.73-12.91h0c3.87-3.18,9.55-2.83,13,.8l535.26,563.47c3.82,4.02,3.43,10.45-.86,13.97Z"></path>
                    <path className="cls-1"
                          d="m1537.57,1653.74l-105.13,37.06c-5.23,1.85-10.93-1.14-12.4-6.49l-205.13-749.61c-1.32-4.84,1.31-9.87,6.04-11.54h0c4.73-1.67,9.94.6,11.94,5.2l310.26,712.55c2.22,5.09-.35,10.99-5.59,12.83Z"></path>
                    <path className="cls-1"
                          d="m1256.57,1819.31l-111.46-1.13c-5.55-.06-9.89-4.81-9.43-10.34l63.62-774.56c.41-5,4.61-8.83,9.63-8.78h0c5.01.05,9.14,3.97,9.45,8.97l47.84,775.7c.34,5.54-4.09,10.21-9.64,10.15Z"></path>
                    <path className="cls-1"
                          d="m935.88,1878.78l-104.35-39.19c-5.2-1.95-7.64-7.9-5.33-12.94l324.7-706.09c2.09-4.56,7.35-6.72,12.05-4.96h0c4.69,1.76,7.23,6.85,5.81,11.66l-220.35,745.28c-1.57,5.32-7.33,8.19-12.53,6.24Z"></path>
                    <path className="cls-1"
                          d="m614.2,1824.98l-84.66-72.52c-4.22-3.61-4.48-10.04-.58-13.99l546.62-552.46c3.53-3.56,9.21-3.8,13.02-.54h0c3.81,3.26,4.45,8.91,1.47,12.94l-461.96,624.97c-3.3,4.46-9.69,5.19-13.91,1.58Z"></path>
                    <path className="cls-1"
                          d="m330.31,1664.41l-54.75-97.1c-2.73-4.83-.78-10.97,4.24-13.34l702.6-332.18c4.53-2.14,9.95-.42,12.41,3.95h0c2.46,4.37,1.13,9.9-3.05,12.67l-647.85,429.28c-4.63,3.07-10.88,1.56-13.61-3.27Z"></path>
                    <path className="cls-1"
                          d="m118.47,1416.42l-18.24-109.97c-.91-5.48,3.02-10.57,8.55-11.08l773.84-71.85c4.99-.46,9.5,3.01,10.32,7.96h0c.82,4.95-2.32,9.69-7.2,10.86l-755.6,181.82c-5.4,1.3-10.76-2.26-11.67-7.73Z"></path>
                    <path className="cls-1"
                          d="m4.21,1110.94l20.47-109.57c1.02-5.46,6.45-8.9,11.82-7.49l751.75,197.16c4.85,1.27,7.89,6.07,6.97,11h0c-.92,4.93-5.49,8.31-10.48,7.74L12.53,1122.19c-5.51-.63-9.34-5.8-8.32-11.26Z"></path>
                    <path className="cls-1"
                          d="m1.33,784.8l56.71-95.96c2.82-4.78,9.11-6.16,13.67-3l638.98,442.38c4.12,2.85,5.34,8.41,2.79,12.72h0c-2.55,4.32-8,5.93-12.49,3.69L5.3,798.22c-4.97-2.47-6.79-8.64-3.97-13.42Z"></path>
                    <path className="cls-1"
                          d="m110.17,477.34l86.12-70.78c4.29-3.52,10.67-2.67,13.87,1.86l449.14,634.24c2.9,4.09,2.14,9.73-1.73,12.91h0c-3.87,3.18-9.55,2.83-13-.8L109.31,491.31c-3.82-4.02-3.43-10.45.86-13.97Z"></path>
                    <path className="cls-1"
                          d="m317.6,225.65l105.13-37.06c5.23-1.85,10.93,1.14,12.4,6.49l205.13,749.61c1.32,4.84-1.31,9.87-6.04,11.54h0c-4.73,1.67-9.94-.6-11.94-5.2L312.02,238.48c-2.22-5.09.35-10.99,5.59-12.83Z"></path>
                    <path className="cls-1"
                          d="m598.61,60.08l111.46,1.13c5.55.06,9.89,4.81,9.43,10.34l-63.62,774.56c-.41,5-4.61,8.83-9.63,8.78h0c-5.01-.05-9.14-3.97-9.45-8.97l-47.84-775.7c-.34-5.54,4.09-10.21,9.64-10.15Z"></path>
                    <path className="cls-1"
                          d="m919.29.61l104.35,39.19c5.2,1.95,7.64,7.9,5.33,12.94l-324.7,706.09c-2.09,4.56-7.35,6.72-12.05,4.96h0c-4.69-1.76-7.23-6.85-5.81-11.66L906.77,6.85c1.57-5.32,7.33-8.19,12.53-6.24Z"></path>
                  </svg>
                </div>
              </div>
            </div>
          <StaticImage
              className="banner__image banner__image--bakers"
              imgClassName="banner__image--content"
              src="../../../static/bakers/Group@2x3.png"
              alt="Two angry bakers making a cake"
              layout="constrained"
              placeholder="blurred"
              transformOptions={{grayscale: false, fit: "contain"}}
              objectFit={"contain"}
              objectPosition="50% 0%"
          />
          </div>

        </Parallax>
    )
  }

  const theBannerContent = (
      <>
        {theHeaderImage}
        <div className="container">
          <Link to={"/"}>
            {/*<StaticImage*/}
            {/*    className="logo__image"*/}
            {/*    imgClassName="banner__image--content"*/}
            {/*    src="../../../static/logo-3.png"*/}
            {/*    alt="A Vulgar Display Of Flour logo"*/}
            {/*    layout="constrained"*/}
            {/*    transformOptions={{grayscale: false, fit: "contain"}}*/}
            {/*    placeholder="blurred"*/}
            {/*/>*/}
          </Link>
        </div>
      </>
  )


  return (
      <ParallaxProvider>
        <BannerModuleStyles className={small ? "small" : null}>
          {children ? (
              children
          ) : (
              theBannerContent
          )}
        </BannerModuleStyles>

        <span id="topContent"/>
      </ParallaxProvider>
      // </div>
  )
}

export default BannerModule
